import React from "react"

export const MapIcon = ({
  size = 1,
  color = "#034055",
  stroke_width = "2.8",
  className = undefined,
}) => {
  return (
    <svg
      className={className}
      width={size * 24}
      height={size * 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        stroke={color}
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeWidth={stroke_width}
        d="M1,22l7-5l7,5l7-5v-15l-7,5l-7-5l-7,5zM8,2v15M15,7v15"
      />
    </svg>
  )
}
